import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import shopptingCart from './views/shoppting-cart'

export default [
  {
    path: RoutePathConstants.SHOPPTING_CART,
    name: 'shopptingCart',
    component: shopptingCart
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/shoppting-cart/routers.js